import { render, staticRenderFns } from "./no_identity.vue?vue&type=template&id=adfc739e&scoped=true"
import script from "./no_identity.vue?vue&type=script&lang=js"
export * from "./no_identity.vue?vue&type=script&lang=js"
import style0 from "./no_identity.vue?vue&type=style&index=0&id=adfc739e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adfc739e",
  null
  
)

export default component.exports